import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DayMonthYearDatePipe } from '../../../../shared/pipes/simple/dayMonthYearDate.pipe';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { PersonStammMasterDetailEntryMeta } from '../../../../core/personstamm-api';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-personstamm-auslaendischerechtsform',
  templateUrl: './personstamm-auslaendischerechtsform.component.html',
  styleUrls: ['./personstamm-auslaendischerechtsform.component.scss'],
  imports: [KopfdatenelementComponent, TranslatePipe, TranslateNamePipe]
})
export class PersonstammAuslaendischeRechtsformComponent implements OnInit {
  @Input()
  public entry: PersonStammMasterDetailEntryMeta;

  constructor(
    public translate: TranslateService,
    public dayMonthYearDatePipe: DayMonthYearDatePipe
  ) {
    keysToTranslate<string>(['Rechtsform']);
  }

  ngOnInit() {}
}
